import {Dialog, DialogActions, DialogContent} from "@material-ui/core";
import {
    ArrayField,
    Button,
    Datagrid,
    DateField,
    DeleteButton, FunctionField,
    NumberField,
    ResourceContextProvider,
    SelectField,
    TextField, useRecordContext,
} from "react-admin";
import {useOptions} from "../../shared/hooks/useOptions";
import {useToggler} from "../../shared/hooks/useToggler";
import {initField} from "../../shared/utils";
import IconCancel from "@material-ui/icons/Cancel";
import {IdentifierField} from "../../components/IdentifierField";
import HistoryIcon from '@material-ui/icons/History';

export const ShowPaymentStatusHistoryButton = () => {
    const {value, setFalse, setTrue} = useToggler();

    const {data: options} = useOptions("payment_schedule_status", "POST");

    return options ? (
        <>
            <Button
                variant="outlined"
                onClick={() => setTrue()}
            ><HistoryIcon/></Button>
            <Dialog open={value} maxWidth="sm" fullWidth>
                <DialogContent>
                    <ArrayField source="status_history">
                        <ResourceContextProvider value={"payment_schedule_status"}>
                            <Datagrid>
                                <IdentifierField {...initField("id", options)} />
                                <DateField {...initField("date", options)} />
                                <SelectField
                                    {...initField("status", options, "array")}
                                    choices={options.status.choices}
                                />
                                <NumberField
                                    {...initField("amount", options)}
                                    label="Importo"
                                    options={{
                                        style: "currency",
                                        currency: "EUR",
                                    }}
                                />
                                <FunctionField
                                    render={(record: any) => record.bank && `${record.bank.id}: ${record.bank.code}`}
                                    source="bank"
                                    label="Banca"
                                />
                                <SelectField
                                    {...initField("collection_type", options, "array")}
                                    choices={options.collection_type.choices}
                                />
                                <TextField {...initField("notes", options)} />
                                <FunctionField
                                    label="Cancella"
                                    source="status"
                                    render={(record: any) => {
                                        if (record && record.status !== "S" && record.status !== "C")
                                            return (<DeleteButton record={record} redirect={false}/>)
                                        return (<></>)
                                    }}/>

                            </Datagrid>
                        </ResourceContextProvider>
                    </ArrayField>
                </DialogContent>
                <DialogActions>
                    <Button label="Chiudi" onClick={setFalse}>
                        <IconCancel/>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    ) : null;
};
